import { isMobileNative } from "util/device";

export const PERMISSION_GRANTED = "GRANTED"; // Android
export const PERMISSION_NOT_REQUESTED = "NOT_REQUESTED"; // Android
export const DENIED_ONCE = "DENIED_ONCE"; // Android
export const DENIED = "DENIED"; // Android
export const NOT_REQUESTED = "NOT_REQUESTED"; // Android
export const DENIED_ALWAYS = "DENIED_ALWAYS"; // Android
export const AUTHORIZED = "authorized"; // iOS
export const AUTHORIZED_WHEN_IN_USE = "authorized_when_in_use"; // iOS
export const NOT_DETERMINED = "not_determined"; // iOS

export const isCameraAuthorized = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.isCameraAuthorized().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });

export const requestCameraAuthorization = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.requestCameraAuthorization().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });

// Only iOS
export const isCameraRollAuthorized = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.isCameraRollAuthorized().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });

// Only iOS
export const requestCameraRollAuthorization = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.requestCameraRollAuthorization().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });

export const switchToSettings = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.switchToSettings().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });

export const getCameraAuthorizationStatus = () =>
    new Promise((resolve, reject) => {
        if (isMobileNative) {
            window.diagnostic.getCameraAuthorizationStatus().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            resolve(false);
        }
    });
